import {
  FETCH_OFFERS,
  SET_SELECTED_OFFER,
  SET_OTP_VERIFIED,
  SET_APP_PHASE,
  SET_LOADING,
  SET_ERROR,
  RESET_APPLICATION,
  SET_CANDIDATE_EMAIL,
} from "./mutation-types";

export default {
  [FETCH_OFFERS](state, offers) {
    state.offers = offers;
  },

  [SET_SELECTED_OFFER](state, offer) {
    state.selectedOffer = offer;
  },

  [SET_OTP_VERIFIED](state, { verified, email }) {
    state.otpVerified = verified;
    state.candidateEmail = email || state.candidateEmail;
  },

  [SET_APP_PHASE](state, phase) {
    state.appPhase = phase;
  },

  [SET_LOADING](state, { key, value }) {
    state.loading[key] = value;
  },

  [SET_ERROR](state, { key, message }) {
    state.errors[key] = message;
  },

  [SET_CANDIDATE_EMAIL](state, email) {
    state.candidateEmail = email;
  },

  [RESET_APPLICATION](state) {
    state.appPhase = "email";
    state.otpVerified = false;
    state.candidateEmail = "";
    state.errors = { offers: "", email: "", otp: "", submit: "" };
    state.loading = {
      offers: false,
      sendOtp: false,
      verifyOtp: false,
      submit: false,
    };
  },
};
